import React from 'react';

import { VpPluginSwitchSection } from './VpPluginSwitchSection';
import { VpPluginTextTitleInputs } from '../..';

export const VpPluginTitleSection = () => {
  return (
    <VpPluginSwitchSection name="showTitle" label="TITLE">
      <VpPluginTextTitleInputs />
    </VpPluginSwitchSection>
  );
};

export default VpPluginTitleSection;



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpPluginDetailsForm/VpPluginTitleSection.jsx